var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('my-nav-bar',{attrs:{"title":_vm.title}}),_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.src}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }